module.exports = __webpack_public_path__ + "static/media/clickaplaylogoamarillo.3c26e484.svg";